import { Button } from "../ui/Button";
import { useT } from "../../lib/use-t";

type Props = {
  selectedLabel: string;
  durationLabel?: string;
  pending: boolean;
  onBegin: () => void;
  ctaLabel: string;
  ctaLabelShort: string;
};

/** Shared sticky bottom action bar. Sticks to the bottom of the scrolling
 *  content column (no hard-coded sidebar offset). Honours the mobile safe-area
 *  inset so it clears the home indicator above the shell's TabBar. */
export function BeginBar({ selectedLabel, durationLabel, pending, onBegin, ctaLabel, ctaLabelShort }: Props) {
  const t = useT();
  return (
    <div
      className="sticky bottom-0 z-10 -mx-5 sm:-mx-8 mt-6 border-t border-[var(--border)] bg-[var(--panel)] px-5 sm:px-8 py-3 sm:py-4 shadow-[0_-8px_24px_-16px_rgba(37,35,31,.2)]"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 0.75rem)" }}
    >
      <div className="flex items-center gap-4">
        <div className="flex flex-col min-w-0">
          <span className="font-mono-badge text-[10px] uppercase tracking-wider text-[var(--ink-faint)]">
            <span className="hidden sm:inline">{t("oefenen.selectedLabel")}</span>
            <span className="sm:hidden">{t("oefenen.selectedLabelShort")}</span>
          </span>
          <span className="font-display font-semibold text-base sm:text-lg truncate">
            {selectedLabel}
          </span>
        </div>
        <div className="flex-1" />
        {durationLabel ? (
          <span className="hidden sm:inline font-mono-badge text-xs text-[var(--ink-faint)]">
            {durationLabel}
          </span>
        ) : null}
        <Button variant="warm" size="lg" onClick={onBegin} disabled={pending}>
          <span className="hidden sm:inline">{ctaLabel}</span>
          <span className="sm:hidden">{ctaLabelShort}</span>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden>
            <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Button>
      </div>
    </div>
  );
}
